module.exports = __webpack_public_path__ + "img/william-stone.6d2477eb.png";